import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ENVIRONMENT, Environment, PhoneConfiguration, ResupplyFlows } from '@domains';
import { Observable } from 'rxjs';

import { BaseApiService } from '../base-api.service';

@Injectable({
  providedIn: 'root',
})
export class PhoneConfigurationService extends BaseApiService<PhoneConfiguration> {
  constructor(
    @Inject(ENVIRONMENT) override config: Environment,
    override http: HttpClient,
  ) {
    super(config, http, 'phone_configurations', PhoneConfiguration, 'PhoneConfiguration', [], ['charity', 'store']);
  }

  flows(): Observable<ResupplyFlows[]> {
    return this.http.get<ResupplyFlows[]>(`${this.config.urls.baseUrl}/phone_configurations/flows`);
  }
}
